import type { Problem } from "@keystone/contracts/shared";
import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export type ApiError = FetchBaseQueryError | SerializedError;

export function isFetchError(e: unknown): e is FetchBaseQueryError {
  return typeof e === "object" && e !== null && "status" in e;
}

export function getProblem(e: ApiError | undefined): Problem | undefined {
  if (!e || !isFetchError(e)) return undefined;
  const body = e.data;
  if (typeof body !== "object" || body === null) return undefined;
  if (!("status" in body) || !("title" in body)) return undefined;
  return body as Problem;
}

export function getErrorCode(e: ApiError | undefined): string | undefined {
  return getProblem(e)?.code;
}
